import * as React from "react";
import { Link } from "react-router-dom";
import type { ClientVATDeclarationStatusType } from "../../../../../../../generated/enums.ts";
import { cn } from "../../../../../../../lib/utils.ts";
import type { ClientVatDeclarationStatus } from "../../models.ts";
import { VAT_DECLARATION_STATUS_LABELS, vatDeclarationLink, vatDeclarationStatusTooltip } from "./vatDeclarationStatus.ts";

const PILL_COLORS: Record<ClientVATDeclarationStatusType, { pill: string; dot: string }> = {
    not_started: { pill: "bg-gray-50 text-gray-500 hover:ring-gray-300", dot: "border border-gray-400 bg-transparent" },
    open: { pill: "bg-gray-100 text-gray-700 hover:ring-gray-300", dot: "bg-gray-400" },
    awaiting_approval: { pill: "bg-amber-50 text-amber-800 hover:ring-amber-300", dot: "bg-amber-500" },
    approved: { pill: "bg-green-50 text-green-700 hover:ring-green-300", dot: "bg-green-500" },
    rejected: { pill: "bg-red-50 text-red-700 hover:ring-red-300", dot: "bg-red-500" },
};

interface Props {
    clientId: string;
    clientName: string;
    declaration: ClientVatDeclarationStatus;
}

export function VatDeclarationStatusPill({ clientId, clientName, declaration }: Props) {
    const colors = PILL_COLORS[declaration.status];
    return (
        <Link
            to={vatDeclarationLink(clientId, declaration)}
            title={vatDeclarationStatusTooltip(declaration, clientName)}
            aria-label={`Btw-aangifte ${clientName}: ${VAT_DECLARATION_STATUS_LABELS[declaration.status]}`}
            onClick={(e) => e.stopPropagation()}
            className={cn(
                "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium hover:ring-1 hover:ring-inset",
                colors.pill,
            )}
        >
            <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", colors.dot)} aria-hidden="true" />
            {VAT_DECLARATION_STATUS_LABELS[declaration.status]}
        </Link>
    );
}
